import React, { useState, useEffect } from 'react';
import { View, StyleSheet, ScrollView, SafeAreaView, Text, Image, TouchableOpacity } from 'react-native';
import { useTheme, List, Divider, Button, Chip, Snackbar } from 'react-native-paper';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import { getItemById } from '../../api/menuAPI';
import LoadingIndicator from '../../components/LoadingIndicator';
import ErrorMessage from '../../components/ErrorMessage';

const MenuItemScreen = ({ navigation, route }) => {
  const theme = useTheme();
  const { itemId } = route.params || {};
  const [menuItem, setMenuItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  
  useEffect(() => {
    loadMenuItemData();
  }, [itemId]);
  
  const loadMenuItemData = async () => {
    if (!itemId) {
      setError('Ürün bilgisi eksik');
      return;
    }
    
    try {
      setLoading(true);
      setError(null);
      
      const response = await getItemById(itemId);
      
      if (response.success) {
        setMenuItem(response.item);
      } else {
        setError('Ürün bilgileri alınamadı');
        setSnackbarMessage('Ürün bilgileri alınamadı');
        setSnackbarVisible(true);
      }
    } catch (err) {
      console.error('Ürün verileri yüklenirken hata:', err);
      setError('Ürün verileri yüklenirken bir hata oluştu');
      setSnackbarMessage('Ürün verileri yüklenirken bir hata oluştu');
      setSnackbarVisible(true);
    } finally {
      setLoading(false);
    }
  };
  
  if (loading) {
    return <LoadingIndicator message="Ürün bilgileri yükleniyor..." />;
  }
  
  if (error) {
    return (
      <ErrorMessage 
        message={error} 
        buttonText="Tekrar Dene" 
        onButtonPress={loadMenuItemData} 
      />
    );
  }
  
  if (!menuItem) {
    return (
      <ErrorMessage 
        message="Ürün bulunamadı" 
        buttonText="Menüye Dön" 
        onButtonPress={() => navigation.navigate('Menu')} 
      />
    );
  }
  
  return (
    <SafeAreaView style={styles.container}>
      <ScrollView>
        <View style={styles.imageContainer}>
          <Image 
            source={{ uri: menuItem.image_url || 'https://picsum.photos/700' }} 
            style={styles.image} 
            resizeMode="cover"
          />
         
         {/* <Text style={styles.headerTitle}>{menuItem.name}</Text> */}
        </View>
        
        <View style={styles.contentContainer}>
          <View style={styles.basicInfo}>
            <Text style={styles.itemName}>{menuItem.name}</Text>
            
            <View style={styles.priceContainer}>
              <Text style={styles.price}>
                {menuItem.price} ₺
              </Text>
              
              
            </View>
          </View>
          
          {menuItem.description && (
            <Text style={styles.description}>
              {menuItem.description}
            </Text>
          )}
          
          {!menuItem.is_available && (
            <Chip 
              mode="outlined" 
              style={styles.unavailableChip}
              textStyle={{color: 'rgb(210, 50, 80)'}}
            >
              Bu ürün şu anda mevcut değil
            </Chip>
          )}
          
          <Divider style={styles.divider} />
          
          <List.Section>
            <List.Subheader style={{color: 'rgb(125, 76, 236)', fontWeight: 'bold'}}>Ürün Bilgileri</List.Subheader>
            
            {menuItem.is_featured && (
              <List.Item
                title="Öne Çıkan"
                description="Bu ürün önerilen ürünler arasındadır"
                left={props => <MaterialCommunityIcons {...props} name="star" size={24} color="rgb(125, 76, 236)" />}
              />
            )}
            
            {menuItem.is_available ? (
              <List.Item
                title="Durum"
                description="Mevcut"
                left={props => <MaterialCommunityIcons {...props} name="checkbox-marked-circle" size={24} color="rgb(125, 76, 236)" />}
              />
            ) : (
              <List.Item
                title="Durum"
                description="Tükendi"
                left={props => <MaterialCommunityIcons {...props} name="close-circle" size={24} color="rgb(210, 50, 80)" />}
              />
            )}
            
            {menuItem.calories !== undefined && (
              <List.Item
                title="Kalori"
                description={`${menuItem.calories} kcal`}
                left={props => <MaterialCommunityIcons {...props} name="fire" size={24} color="rgb(125, 76, 236)" />}
              />
            )}
           
            
            {menuItem.category && (
              <List.Item
                title="Kategori"
                description={menuItem.category.name}
                left={props => <MaterialCommunityIcons {...props} name="food-fork-drink" size={24} color="rgb(125, 76, 236)" />}
              />
            )}
          </List.Section>
        </View>
      </ScrollView>
      
      <Snackbar
        visible={snackbarVisible}
        onDismiss={() => setSnackbarVisible(false)}
        duration={3000}
        style={{backgroundColor: 'rgb(125, 76, 236)'}}
        theme={{colors: {surface: '#fff'}}}
        action={{
          label: 'Tamam',
          onPress: () => setSnackbarVisible(false),
          color: '#fff'
        }}
      >
        {snackbarMessage}
      </Snackbar>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgb(232, 162, 249)',
  },
  imageContainer: {
    height: 300,
    position: 'relative',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  backButton: {
    position: 'absolute',
    top: 16,
    left: 16,
    backgroundColor: 'rgba(0,0,0,0.3)',
    borderRadius: 20,
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerTitle: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(125, 76, 236, 0.8)',
    color: '#fff',
    padding: 16,
    fontSize: 22,
    fontWeight: 'bold',
    paddingVertical: 20,
  },
  contentContainer: {
    padding: 16,
    backgroundColor: 'white',
    marginHorizontal: 16,
    marginTop: 16,
    borderRadius: 12,
    elevation: 4,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    borderWidth: 1,
    borderColor: 'rgba(125, 76, 236, 0.3)',
    marginBottom: 16,
  },
  basicInfo: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  itemName: {
    fontSize: 26,
    fontWeight: 'bold',
    flex: 1,
    color: 'rgb(125, 76, 236)',
  },
  priceContainer: {
    alignItems: 'flex-end',
  },
  price: {
    fontSize: 22,
    fontWeight: 'bold',
    color: 'rgb(125, 76, 236)',
  },
  discountPrice: {
    fontSize: 16,
    textDecorationLine: 'line-through',
    color: 'rgba(125, 76, 236, 0.6)',
  },
  description: {
    fontSize: 16,
    lineHeight: 24,
    color: 'rgb(90, 50, 180)',
    marginBottom: 16,
  },
  unavailableChip: {
    backgroundColor: 'rgba(210, 50, 80, 0.2)',
    marginBottom: 16,
    alignSelf: 'flex-start',
    borderColor: 'rgb(210, 50, 80)',
  },
  divider: {
    marginVertical: 16,
    backgroundColor: 'rgba(125, 76, 236, 0.3)',
    height: 1,
  },
});

export default MenuItemScreen;
